import React from 'react';
import PropTypes from 'prop-types';

const LegType = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Jafngreiðslulán (Annuitet) (01)";
      break;
    case 2:
      displayText = "Jafnar afborganir samningsvextir á v. (02)";
      break;
    case 3:
      displayText = "Óreglulegar afborganir (03)";
      break;
    case 10:
      displayText = "Jafngreiðslulán RB (Annuitet) (10)";
      break;
    default:
      displayText = "Ekki þekkt tegund";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

LegType.propTypes = {
  data: PropTypes.number,
};

export default LegType;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Display/LegType.js